import { Flex, BoxProps } from '@wegroup/design-system';
import React from 'react';
import { chakraCustomScrollBar } from '../../../../../../../common/src/utils/styledComponentsUtils';

const CompanyScanToolbarWrapper: React.FC<
  React.PropsWithChildren<BoxProps>
> = ({ children, ...props }) => {
  return (
    <Flex
      flexDir="column"
      bg="gray.ultraLight"
      w={{ base: '100%', laptop: '80' }}
      h="100%"
      pt={{ base: '3', laptop: '8' }}
      pb={{ base: '3', laptop: '8' }}
      pr={{ base: '3', laptop: '6' }}
      pl={{ base: '3', laptop: '10' }}
      ml={{ base: '0', laptop: '-4' }}
      flexShrink={0}
      overflowY="auto"
      sx={chakraCustomScrollBar}
      {...props}
    >
      {children}
    </Flex>
  );
};

export default CompanyScanToolbarWrapper;
